'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$18() {
  this.aK1 = null;
  this.aK2 = false;
}
export { $c_Lpresto_DashboardView$$anon$18 as $c_Lpresto_DashboardView$$anon$18 };
$p = $c_Lpresto_DashboardView$$anon$18.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$18;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$18() {
}
export { $h_Lpresto_DashboardView$$anon$18 as $h_Lpresto_DashboardView$$anon$18 };
$h_Lpresto_DashboardView$$anon$18.prototype = $p;
$p.P = (function() {
  if ((!this.aK2)) {
    this.aK1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T3($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.aK2 = true;
  }
  return this.aK1;
});
var $d_Lpresto_DashboardView$$anon$18 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$18, "presto.DashboardView$$anon$18", ({
  GK: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_DashboardView$$anon$18 as $d_Lpresto_DashboardView$$anon$18 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$18.js.map
